<template>
  <div>
    <hr class="mt-4 mb-5" />
    <div class="form-group mb-4">
      <PromoCodeForm type="in-store" placeholder="TWO4ONE" />
    </div>
    <hr class="mt-4 mb-5" />
    <div class="form-group mb-4">
      <PromoCodeForm type="off-premise" placeholder="BOGO324" />
    </div>
  </div>
</template>

<script>
import PromoCodeForm from './PromoCodeForm'

export default {
  name: 'CreatePromoCodeView',
  components: {
    PromoCodeForm
  }
}
</script>
